module.exports = __webpack_public_path__ + "img/vertical_3_3_5010.3b75e92e.png";